<template>
	<AppDialog
		height="600"
		closeTop="-30"
		max-width="950"
		closeRight="-2"
		disable-max-width
		ref="dialog_container"
		:dialogName="'CreationWizardDialog'"
	>
		<div class="dialog-content">
			<CreationWizard @close-wizard="closeWizard" v-bind="$attrs" @start-creation-process="startCreationProcess" />
		</div>
	</AppDialog>
</template>

<script>
import CreationWizard from '@/components/CreationWizard/CreationWizard.vue';
import AppDialog from '@/components/dialogs/AppDialog/AppDialog';
import ExtensionCommunicationService from '@/utils/extension-communication-service';
export default {
	name: 'CreationWizardDialog',
	components: {
		AppDialog,
		CreationWizard,
	},
	methods: {
		closeWizard() {
			this.$refs.dialog_container.closeCurrentDialog();
		},
		startCreationProcess(creationProcessMessage) {
			return ExtensionCommunicationService.startCreationProcess(creationProcessMessage);
		},
	},
};
</script>

<style scoped lang="scss">
.dialog-content {
	height: 600px;
}
</style>
